import { gql } from "@apollo/client";

export const PROGRAMMING_STRUCTURES_STAGES_QUERY = gql`
  query programmingStructuresStages($scenarioId: ID!) {
    data(scenarioId: $scenarioId) {
      programmingStructureStages {
        items {
          id
          code
          name
          programmingStructureStageType {
            id
            code
            name
          }
        }
        pageInfo {
          size
          page
          total
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
`;
